import React from "react";
import {Button, Modal} from 'react-bootstrap';

import MdClose from "react-ionicons/lib/MdClose";

import {deleteDocument} from '../../../api/Document';

function DocumentDelete(props) {
    const [modalShow, setModalShow] = React.useState(false);

    return (
        <>
            <MdClose fontSize="30px" color="red" onClick={() => setModalShow(true)} />

            <WarningModal
                show={modalShow}
                id={props.id}
                filename={props.filename}
                onHide={() => setModalShow(false)}
            />
        </>
    )
}

function WarningModal(props) {
    async function handleDelete() {
        const deleted = await deleteDocument(props.id);

        if (deleted.status === 200) {
            window.location.reload()
        }
    }

    console.log(props)

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Confirmation de suppression
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Êtes-vous sur de vouloir supprimer le document <b>"{props.filename}"</b> ?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>Annuler</Button>
                <Button variant="danger" onClick={handleDelete}>Confirmer</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DocumentDelete;
